<template>
  <div class="pb-4">
    <slot name="header" v-bind:toggle="toggle" v-bind:locations="locations"></slot>
    <locations-map @click="toggle" :locations="locations" :geojson="geojson" v-if="geojson" :center="mapCenter" :zoom="mapZoom"></locations-map>
  </div>
</template>

<script>
import LocationsMap from "./LocationsMap";

export default {
  name: "LocationsContainer",

  components: {
    LocationsMap
  },

  props: ["selectedLocationIds", "mapCenter", "mapZoom"],

  data() {
    return {
      locations: [],
      geojson: null,
      menu: false
    }
  },

  created() {
    this.$store.dispatch("ajax", {
      url: "/v1/wizard/locations",
      method: "get"
    }).then(res => {
      res.locations.forEach(location => {
        let active = true;

        if (this.selectedLocationIds) {
          active = false;

          if (this.selectedLocationIds.indexOf(location.locationId) != -1) {
            active = true;
          }
        }

        this.locations.push({
          locationId: location.locationId,
          name: location.name,
          parentId: "parentId" in location ? location.parentId : null,
          active: active,
          children: []
        });
      });

      this.locations.forEach(location => {
        if (location.parentId != null) {
          const parent = this.locations.find(l => l.locationId == location.parentId);
          if (parent) {
            parent.children.push(location.locationId);
          } else {
            location.parentId = null;
          }
        }
      });

      this.sendUpdate();
    });

    this.$store.dispatch("ajax", {
      url: "/v1/wizard/locations/geojson",
      method: "get"
    }).then(res => {
      this.geojson = res;
    });
  },

  methods: {
    toggle(location) {
      if (location.active) {
        location.active = false;
      } else {
        location.active = true;
      }

      if (location.children.length > 0) {
        location.children.forEach(childId => {
          const child = this.locations.find(l => l.locationId == childId);
          child.active = location.active;
        });
      }

      if (location.parentId > 0) {
        // sorgt dafür das wenn alle children aktiv sind, die mutter auch aktiv ist
        const parent = this.locations.find(l => l.locationId == location.parentId);
        let equal = true;
        parent.children.forEach(childId => {
          const child = this.locations.find(l => l.locationId == childId);
          if (child.active != location.active) {
            equal = false;
          }
        });

        if (equal) {
          parent.active = location.active;
        }
      }

      this.locations = [...this.locations];
      this.sendUpdate();
    },

    sendUpdate() {
      const payload = this.locations.filter(location => location.active);
      this.$emit("update", payload);
    }
  }
};
</script>
